import {
	QueryParameterType
} from 'random/query-params';

export default {
	initialDate: QueryParameterType.DATE_TIME,
	finalDate: QueryParameterType.DATE_TIME
};